import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

import {
  HelpButton,
  HelpIntro,
  HelpScreen,
  HelpSection,
} from "@/components/help/help-ui";

const topics = () => [
  i18n.t("help.topics.items.profile"),
  i18n.t("help.topics.items.visible"),
  i18n.t("help.topics.items.chats"),
  i18n.t("help.topics.items.groups"),
  i18n.t("help.topics.items.goals"),
  i18n.t("help.topics.items.sharing"),
  i18n.t("help.topics.items.practice"),
  i18n.t("help.topics.items.billing"),
  i18n.t("help.topics.items.privacy"),
];

export default function HelpTopics() {
  useTranslation();
  const router = useRouter();

  return (
    <HelpScreen title={i18n.t("help.topics.title")}>
      <HelpIntro>{i18n.t("help.topics.intro")}</HelpIntro>

      <HelpSection heading={i18n.t("help.topics.heading")} bullets={topics()} />

      <HelpSection heading={i18n.t("help.topics.stillNeedHelp")} />
      <HelpButton
        label={i18n.t("help.common.contactSupport")}
        icon="chatbubbles-outline"
        onPress={() => router.push("/help/contact?source=contact")}
      />
    </HelpScreen>
  );
}
